import { ReactNode } from 'react';
import { REPORT_MALICIOUS_EMAIL_FORM_URL } from '../../../../../constants';

export const ATTACHMENT_SCAN_MESSAGES = {
  REJECTED: 'A file was rejected as malicious. Submit an Ellis to report it to the Security team.'
} as const;

export const renderAttachmentErrorMessage = (error: string): ReactNode => {
  if (error === ATTACHMENT_SCAN_MESSAGES.REJECTED) {
    return (
      <span>
        A file was rejected as malicious.{' '}
        <a href={REPORT_MALICIOUS_EMAIL_FORM_URL} target="_blank" rel="noopener noreferrer">
          Submit an Ellis
        </a>{' '}
        to report it to the Security team.
      </span>
    );
  }

  return error;
};
